import React from "react";
import "./LibraryAudio.css";

export default function LibraryAudio() {
  /* =====================================================
     BOOK DATA
  ===================================================== */

 const books = [
  {
    bookName: "BAHARE SARIYAT PART - 2 || 1 TAMHIIDI KALIMAT",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1-UyiqIH9Y1Il6T1LPHfGsb6IJRv-w1jT",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 2 KITABUTTAHAARAT",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1xWu1rZj0wUVkuWyE6VUbq1nbI6lXFjk9",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 3 - WUDU KA BAYAN",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1BRWhZobUD_yDkA9Vt2qd40JcIZluK7ZI",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 4 - WUDU KE AHKAME FITHIYA",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1zL0ucYOEdZ8dQKrw3p3iN-zbSwqsBQs3",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 5 - WUDU KI SUNNATE",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=12NLcJbl8jabPgRkvvF_2jivFD19RcEr4",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 6 - WUZU KE MUSTAHABBAT",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1yX-T6vXj4uPT_KPT0nG1Q-F9JzMU5qa_",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 7 - WUZU KE MUTAFFARIK MASAIL",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1Fn-LLbL2Y4V6X1MrXD0D4eP1L-2QF1mp",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 8 - WUZU KE MAKRUHAT",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1-YTde-Ot07WV9RCecDOmqO2UFTnE5eYt",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 9 - WUZU TORNE WALI CHEEZON KA BAYAN",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1-3f02-JJVSysqPQ0l8WizALDQQD9XKkm",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 10 - MUTAFFARIK MASAIL",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1L7TwyJRsmTzllgc-k4WE_X2DKdg-DFbX",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 11 - GUSL KA BAYAN",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1LdSEQxiqdsDpeaO6KjEv_pNllDB1V46m",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 11 - GUSL KE MASAIL",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1CiSCamtFpOQaksb4tLlYLo44NskYe6lH",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 12 - GUSL KI SUNNATE",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1AYFsbuoDreELZVhqQHprHJspPE7-qhvl",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 13 - GUSL KIN CHEEZON SE FARZ HOTA HAI",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1B-2LuibaxvpScDpSq5ra3rE06oVsdsiD",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 14 - PANI KA BAYAN",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1RaI8_T3xBjR89HduheUHRXmb8-eNMj3Z",
  },

  {
    bookName:
      "BAHARE SARIYAT PART - 2 || 15 - KIS PANI SE WUZU JAIZ HE AUR KIS SE NAHI",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1kKhTvjzr93Y5nqHF3wwQvoe3DAZigtoU",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 16 - KUVEN KA BAYAN",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1LnAr7n_8aGIBIjOOdemDhT_LaL6h_G_J",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 17 - AADMI AUR JANVAR JUTHE KA BAYAN",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=16blGpq5Z9-mUU7cKmjY0RTLMYRZyRLHT",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 18 - TAYAMMUM KA BAYAN",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1rkKII85buQhBx6jGtA2YwKwkCUIYWsHN",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 19 - TAYAMMUM KE MASAIL",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1hbSG5jfI1a303z-eQ8890DG0DgvEs6ZG",
  },

  {
    bookName:
      "BAHARE SARIYAT PART - 2 || 20 - TAYAMMUM KA TARIKA & TAYAMMUM ME KITNI BATEIN FARZ HAI",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1JG1YtLTA_ZdKyzueAuf6PqKC0FiiDuj6",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 21 - TAYAMMUM KI SUNNATE",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1dXIHU4c5siMqanhEcqO-s4uV9oO6JZMB",
  },

  {
    bookName:
      "BAHARE SARIYAT PART - 2 || 22 - TAYAMMUM KIS CHEEZ SE JAIZ HAI AUR KIS SE NAHI",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1skNcyWuKMVWEhrgSKPOWmmfymgZh_nDV",
  },

  {
    bookName:
      "BAHARE SARIYAT PART - 2 || 23 - TAYAMMUM KIN CHEEZON SE TUTTA HAI",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1U8QkiXaz4UpPZnzU64dxE1RQcuAUqw1q",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 24 - MOZO PAR MASAH KA BAYAN",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=113icEHfGQiZy7Ze5tfQLB0D5V7kNvWJd",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 25 - MOZO PAR MASAH KE MASAIL",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1Wt6u11a9_Sx_4yy4PNf4EeyjRcx6NqKY",
  },

  {
    bookName:
      "BAHARE SARIYAT PART - 2 || 26 - MASAH KIN CHEEZON SE TUT JATA HAI",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=10pX40Z6wE_EzpuXbKLeQKNzsYMsobdte",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 27 - HEZ KA BAYAN",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1_hCugDGjM_aeg-s5d29KvS4bQ-ghCyj2",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 28 - HEZ KE MASAIL",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1scRYA7Az_oVfpArrIudzJKnMv4UzoVcJ",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 29 - NIFAS KE BAYAN",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1qvDlW38qtQJbxi_UnH1L6iHVLjukYWI9",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 30 - HEZ AUR NIFAS KE AHKAM",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1Fdzox88b1CMvu0fgKR41VSo08yh-l7iB",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 31 - ISTIHAZA KA BAYAN",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1Oz0W6Urc0JODnIPnv7Aj1CwPzadNTo6v",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 32 - ISTIHAZA KE AHKAM",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1YSAPQ_A3NfdON7MR1o48Qbfq0mGgsewO",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 33 - NAZASATON KA BAYAN",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1afTpRYbkDLYcf8zZgV6NxAsCcYfn7pCi",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 34 - NAZASATON KE AHKAM",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1tC_ggHwb4bgAv7VGEs5yqm7CBpFmnlE_",
  },

  {
    bookName:
      "BAHARE SARIYAT PART - 2 || 35 - NAJIS CHEEZON KE PAK KARNE KA TARIKA",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1AHnSU-BWh3-eS16NeRqSBwWFSN7_Mr4w",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 36 - ISTINZE KA BAYAN",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1WoaK7YdOhXPqO9oZMUaReardUVdfSHwQ",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 37 - ISTINZE KE MASAIL",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1VogmBS9xxIMvyj6SUFz_zn4z4T2WowqX",
  },

  {
    bookName: "BAHARE SARIYAT PART - 2 || 38 - KHANE KE MUTA'LIQ",
    writer: "MOLAN SAIYED ASIF SAHAB",
    publisher: "Misbahi Publication",
    language: "Urdu",
    audio:
      "https://drive.google.com/uc?export=download&id=1zkUF5YLlSDUi34FoAA9o2i1dVLEwZQiw",
  },
];


  /* =====================================================
     OPEN PDF
  ===================================================== */

  const handleReadPDF = (pdf) => {
    window.open(pdf, "_blank");
  };


  /* =====================================================
     DOWNLOAD PDF
  ===================================================== */

  const handleDownloadPDF = (pdf, bookName) => {
    const link = document.createElement("a");

    link.href = pdf;
    link.download = `${bookName}.pdf`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };


  /* =====================================================
     DOWNLOAD AUDIO
  ===================================================== */

  const handleDownloadAudio = (audio, bookName) => {
    const link = document.createElement("a");

    link.href = audio;
    link.download = `${bookName}.mp3`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };


  /* =====================================================
     PAGE
  ===================================================== */

  return (
    <div className="library-audio-page">

      <div className="container">

        {/* HEADER */}

        <div className="library-audio-header">

          <div className="library-audio-bismillah">
            بِسْمِ اللهِ الرَّحْمٰنِ الرَّحِيْمِ
          </div>

          <h1 className="library-audio-title">
            🎧 Audio Library
          </h1>

          <h2 className="library-audio-arabic-title">
            المَكْتَبَةُ الصَّوْتِيَّةُ
          </h2>

          <div className="library-audio-divider">
            <i className="bi bi-star-fill"></i>
          </div>

          <p className="library-audio-description">
            Explore our collection of Islamic books and
            educational resources dedicated to spreading
            knowledge, faith, and spiritual guidance.
          </p>

        </div>


        {/* BOOK COLLECTION */}

        <div className="row g-4 library-audio-books">

          {books.map((book, index) => (

            <div
              className="col-12 col-md-6 col-lg-4"
              key={index}
            >

              <div className="library-audio-card">

                {/* BOOK ICON */}

                <div className="library-audio-icon">

                  <i className="bi bi-book-half"></i>

                </div>


                {/* CARD BODY */}

                <div className="library-audio-card-body">

                  <h3 className="library-audio-book-name">
                    {book.bookName}
                  </h3>


                  {/* BOOK DETAILS */}

                  <div className="library-audio-details">

                    {/* WRITER */}

                    <div className="library-audio-detail">

                      <div className="library-audio-detail-icon">
                        <i className="bi bi-person-fill"></i>
                      </div>

                      <div>

                        <span className="library-audio-detail-label">
                          Writer
                        </span>

                        <p className="library-audio-detail-value">
                          {book.writer}
                        </p>

                      </div>

                    </div>


                    {/* PUBLISHER */}

                    <div className="library-audio-detail">

                      <div className="library-audio-detail-icon">
                        <i className="bi bi-building"></i>
                      </div>

                      <div>

                        <span className="library-audio-detail-label">
                          Publisher
                        </span>

                        <p className="library-audio-detail-value">
                          {book.publisher}
                        </p>

                      </div>

                    </div>


                    {/* LANGUAGE */}

                    <div className="library-audio-detail">

                      <div className="library-audio-detail-icon">
                        <i className="bi bi-translate"></i>
                      </div>

                      <div>

                        <span className="library-audio-detail-label">
                          Language
                        </span>

                        <p className="library-audio-detail-value">
                          {book.language}
                        </p>

                      </div>

                    </div>

                  </div>


                  <div className="library-audio-card-divider"></div>


                  {/* =================================================
                      AUDIO SECTION
                  ================================================= */}

                  <div className="library-audio-section-title">

                    <i className="bi bi-headphones me-2"></i>

                    Audio

                  </div>


                  {/* AUDIO PLAYER */}

                  <audio
                    controls
                    preload="auto"
                    className="w-100 mt-2"
                    src={book.audio}
                  >
                    Your browser does not support audio.
                  </audio>


                  {/* DOWNLOAD AUDIO */}

                  <button
                    type="button"
                    className="library-audio-download mt-2"
                    onClick={() =>
                      handleDownloadAudio(
                        book.audio,
                        book.bookName
                      )
                    }
                  >

                    <i className="bi bi-download me-2"></i>

                    Download Audio

                  </button>


                  {/* =================================================
                      PDF SECTION
                  ================================================= */}

                  <div className="library-audio-section-title mt-4">

                    <i className="bi bi-file-earmark-pdf me-2"></i>

                    PDF Book

                  </div>


                  {/* READ PDF */}

                  <button
                    type="button"
                    className="library-audio-pdf-read"
                    onClick={() =>
                      handleReadPDF(book.pdf)
                    }
                  >

                    <i className="bi bi-book me-2"></i>

                    Read PDF

                  </button>


                  {/* DOWNLOAD PDF */}

                  <button
                    type="button"
                    className="library-audio-pdf-download mt-2"
                    onClick={() =>
                      handleDownloadPDF(
                        book.pdf,
                        book.bookName
                      )
                    }
                  >

                    <i className="bi bi-download me-2"></i>

                    Download PDF

                  </button>


                  {/* =================================================
                      LIKE & SHARE
                  ================================================= */}

                  <div className="library-audio-social">

                    <button
                      type="button"
                      className="library-audio-like"
                    >

                      <i className="bi bi-heart me-1"></i>

                      Like

                    </button>


                    <button
                      type="button"
                      className="library-audio-share"
                    >

                      <i className="bi bi-share me-1"></i>

                      Share

                    </button>

                  </div>

                </div>

              </div>

            </div>

          ))}

        </div>

      </div>

    </div>
  );
}